// Definitions

(function() {

  if (typeof window.SITE === "undefined") {
    window.SITE = {};
  }

})();


// Invocations

$(function () {

  $('select').each(function() {
    var dropdownAnchor = $(this).siblings('.dropdown-anchor');

    $(this).select2({
      theme: 'classic',
      minimumResultsForSearch: Infinity,
      width: '100%',
      dropdownParent: dropdownAnchor,
      allowClear: true
    });
  });
});


jQuery(document).ready(function(){
 jQuery('select').select2({
   theme: 'classic',
   minimumResultsForSearch: Infinity,
   width: '100%',
   allowClear: true
 })
});
